module.exports = __webpack_public_path__ + "img/7.3db41dd7.png";